import React from 'react';
import { LockIcon, StarIcon } from 'lucide-react';
export function CheckoutTrustElements() {
  return <div className="w-full bg-stone-50 py-8" data-id="element-151">
      <div className="max-w-2xl mx-auto px-4" data-id="element-152">
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-153">
          <LockIcon className="w-5 h-5 text-emerald-700" data-id="element-154" />
          <span className="text-stone-700 font-semibold" data-id="element-155">
            Secure encrypted checkout
          </span>
        </div>
        <div className="flex items-center justify-center gap-4 mb-3 flex-wrap" data-id="element-156">
          <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="Visa" className="h-8 opacity-70" data-id="element-157" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-8 opacity-70" data-id="element-158" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="American Express" className="h-8 opacity-70" data-id="element-159" />
        </div>
        <p className="text-center text-sm text-stone-600 mb-6" data-id="element-160">
          Secure, encrypted checkout with Visa, Mastercard, Amex.
        </p>
        <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-161">
          <div className="flex gap-1 mb-2" data-id="element-162">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-163" />)}
          </div>
          <p className="text-sm text-stone-700 italic" data-id="element-164">
            "Natural remedies finally make sense. I've stopped buying cold
            medicine constantly." — Maria C.
          </p>
        </div>
      </div>
    </div>;
}